import React from 'react'

export default (props) => (
  <svg width='24' height='30' viewBox='0 0 24 30' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_17474_482)'>
      <path opacity='0.5' d='M0 2C0 0.89543 0.895431 0 2 0H17V4C17 5.65685 18.3431 7 20 7H24V28C24 29.1046 23.1046 30 22 30H2C0.89543 30 0 29.1046 0 28V2Z' fill='#858585' />
      <path d='M24 7L17 0V6C17 6.55228 17.4477 7 18 7H24Z' fill='#858585' />
    </g>
    <defs>
      <clipPath id='clip0_17474_482'>
        <rect width='24' height='30' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
